// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Pervasives from "rescript/lib/es6/pervasives.js";

var root = document.querySelector("#app");

if (root == null) {
  Pervasives.failwith("DOM node `#app` not found");
} else {
  ReactDom.render(React.createElement(App.make, {}), root);
}

export {
  
}
/* root Not a pure module */
